import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserModel } from '../../model/IUser';
import { GenericValidator } from '../../validation/general-validation';
import { CommonService } from '../../service/common.service';
import { AuthService } from '../../service/auth.service';
import { Router } from '@angular/router';
import { Globals } from '../../globals';
import { RegistrationValidator } from '../../validation/validator';
import { CompanyService } from 'src/app/service/company.service';
import { ConfigurationsService } from 'src/app/Service/configurations.service';

@Component({
  templateUrl: './registration.component.html'
})
export class RegistrationComponent implements OnInit {

  //Property declaration
  registerForm: FormGroup;
  passwordFormGroup: FormGroup;
  user: UserModel = new UserModel();
  displayMessage: { [key: string]: string } = {};
  displayPWMessage: { [key: string]: string } = {};
  displayMobMessage: string = '';
  displayZipMessage: string = '';
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;
  errorMsg: string = '';
  successMsg: string = '';
  disablebtn: boolean = false;
  CountryList = [];
  logopath: string = '';
  CompanyCode: string;
  constructor(private formBuilder: FormBuilder, private configService: ConfigurationsService, private authService: AuthService, private commonservice: CommonService, private companyservice: CompanyService, private router: Router, private _global: Globals) {
    this.CompanyCode = localStorage.getItem("CompanyCode");
    //Raise Validation message
    this.authService.getValidationMessage().subscribe(resp => {
      this.validationMessages = resp.registerForm;
      this.genericValidator = new GenericValidator(this.validationMessages);
    });
  }

  ngOnInit(): void {
    //Password form group for password formControlname and validation initialization
    this.passwordFormGroup = this.formBuilder.group({
      Password: ['', [
        Validators.required,
        Validators.pattern(this._global.passwordpattern)]],
      ConfPassword: ['', [Validators.required]]
    },
      {
        validator: RegistrationValidator.validate.bind(this)
      })

    //Intialize register form group for formcontrolname and validation
    this.registerForm = this.formBuilder.group({
      FirstName: ['', [Validators.required]],
      LastName: ['', [Validators.required]],
      LoginId: ['', [Validators.required, Validators.email]],
      Mobile: ['', [Validators.required]],
      passwordFormGroup: this.passwordFormGroup,
      AddrLine1: ['', Validators.required],
      AddrLine2: [''],
      City: ['', [Validators.required]],
      ZipCode: ['', [Validators.required]],
      Country: ['', [Validators.required]],
      State: ['', [Validators.required]]
    });

    // Call service for validation on valu change
    this.registerForm.valueChanges.subscribe(
      value => this.displayMessage = this.genericValidator.processMessages(this.registerForm)
    );

    // Call service for validation on valu change
    this.passwordFormGroup.valueChanges.subscribe(
      value => this.displayPWMessage = this.genericValidator.processMessages(this.passwordFormGroup)
    );

    setTimeout(() => {
      this.GetCompanyDetails(this.CompanyCode);
      this.GetCountryList();
    }, 1000);
  }

  // Call service for validation on blur
  blur(): void {
    this.displayMessage = this.genericValidator.processMessages(this.registerForm);
    this.displayPWMessage = this.genericValidator.processMessages(this.passwordFormGroup);
  }

  //Service call on save button
  onSubmit() {
    this.successMsg = '';
    this.errorMsg = '';
    this.displayZipMessage = '';
    this.displayMobMessage = '';

    if (this.registerForm.invalid) {
      this.registerForm.updateValueAndValidity();
      this.displayMessage = this.genericValidator.processMessages(this.registerForm, true);
      this.displayPWMessage = this.genericValidator.processMessages(this.passwordFormGroup, true);
      return;
    }

    var reqparam = { ...this.user, ...this.registerForm.value }
    this.disablebtn = true;

    if (this.registerForm.value.Country == 'IN') {
      if (reqparam.Mobile.length != 10) {
        //this.errorMsg = 'Mobile No must have 10 digits.';
        this.displayMobMessage = 'Mobile number should be 10 digits';
        return false;
      } else {
        this.displayMobMessage = '';
      }

      if (reqparam.ZipCode.length != 6) {
        //this.errorMsg = 'Zip Code must have 6 digits.';
        this.displayZipMessage = 'Zip Code should be 6 digits';
        return false;
      } else {
        this.displayZipMessage = '';
      }
    }

    let ReqObj =
    {
      FirstName: reqparam.FirstName,
      LastName: reqparam.LastName,
      LoginId: reqparam.LoginId,
      MobileNo: reqparam.Mobile,
      Password: reqparam.passwordFormGroup.Password,
      Address1: reqparam.AddrLine1,
      Address2: reqparam.AddrLine2,
      City: reqparam.City,
      ZipCode: reqparam.ZipCode,
      CountryId: reqparam.Country,
      State: reqparam.State,
      CompanyCode:localStorage.getItem('CompanyCode')

    }

    this.authService.RegisterUser(ReqObj).subscribe(
      (result) => {
        if (+result > 0) {
          this.successMsg = "User added Successfully!!"
        }
      },
      (error) => {
        this.errorMsg = error
      }
    )
  }

  //Call for get Country List
  GetCountryList() {
    this.commonservice.GetCountryList().subscribe(
      (result) => {
        this.CountryList = result;
      },
      (error) => {
        this.errorMsg = error;
      }
    )
  }

  // Called on change Country
  OnChangeCountry(event) {
    this.registerForm.patchValue({
      Country: event.value
    })
  }

  // get Company Details
  GetCompanyDetails(CompanyCode) {
    this.companyservice.GetCompanyDetailsByCompanyCode(CompanyCode).subscribe(
      (result) => {
        if (result) {
          if (result.LogoPath != null) {
            this.logopath = this.configService.serviceUrl('ServiceURL') + result.LogoPath;
          }
        }

      },
      (error) => {

      }
    )
  }

}
